/* ---------------------------------------------------------------
   HEIDI — Disponibilité de la carte produit, 31/07/2026.

   Une SEULE surcouche par page, rendue au niveau du `<body>` par
   `snippets/hs-availability-sheet.liquid`. Ce fichier la remplit, la place et l'ouvre.

   POURQUOI LE SURVOL EST PASSÉ DU CSS AU JAVASCRIPT — c'est un renversement de la
   décision du matin, et il est imposé par une mesure. Le panneau vivait dans la carte et
   s'ouvrait en `:hover` pur, ce qui ne dépendait d'aucun script. Mais `assets/vendor.css`
   pose `.slick-list{overflow:hidden}` ET
   `.slick-slider .slick-list,.slick-slider .slick-track{transform:translate3d(0,0,0)}`,
   sans condition. Le premier découpe toute surcouche intérieure ; le second fait de la
   piste le bloc conteneur d'un enfant en `position: fixed`, qui cesse alors d'être ancré
   au viewport. Aucune surcouche vivant DANS la carte ne peut donc fonctionner dans un
   carrousel — et la carte est en carrousel sur l'accueil, les produits similaires et les
   récemment consultés.

   Ce que la panne du script coûterait, et c'est pourquoi le compromis est tenable : le
   libellé court — « En stock » — reste visible en clair sur la carte, et la phrase
   complète reste dans le nom accessible du bouton.

   TOUT EST DÉLÉGUÉ AU DOCUMENT. Les grilles sont re-rendues en AJAX à chaque filtre,
   chaque tri et chaque page suivante, et slick clone ses diapositives : un écouteur posé
   sur les boutons au démarrage serait perdu au premier filtre.

   DEUX PRÉDICATS ET NON UN SEUL, et c'est le correctif le plus important du fichier.
   La largeur commande la MISE EN PAGE — feuille ancrée en bas sous 1025 px, panneau
   flottant au-dessus. La capacité de survol commande l'INTERACTION. Les confondre casse
   la pastille sur une tablette tactile large : un écran tactile émet `mouseover` AVANT
   `click`, donc le survol ouvrait la surcouche et le clic qui suit la refermait dans le
   même geste. `(hover: hover)` est la seule question qui vaille pour décider d'écouter
   le survol.

   Fichier séparé et non bloc `{% javascript %}` : Shopify concatène ces blocs en un seul
   fichier, où une exception arrête tout ce qui suit, y compris le code des autres
   sections.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  var DELAI_FERMETURE = 140; // laisse la souris traverser le vide entre pastille et panneau
  var CORPS_OUVERT = 'hs-avail-show'; // convention d'Ella : `body.<chose>-show{overflow:hidden}`

  var feuille = null;
  var voile = null;
  var sortie = null;
  var declencheur = null;   // le bouton qui a ouvert la surcouche
  var epingle = false;      // ouverte au doigt ou au clavier : elle ne se ferme pas au survol
  var minuteur = null;

  // Doit refléter EXACTEMENT la media query de `heidi-shared.css`, sinon le script
  // placerait en coordonnées absolues une surcouche que le CSS ancre en bas.
  function feuilleBas() {
    return window.matchMedia && window.matchMedia('(max-width: 1024px)').matches;
  }
  function survolPossible() {
    return window.matchMedia && window.matchMedia('(hover: hover)').matches;
  }

  // Les éléments sont cherchés à la demande et non au démarrage : le theme editor
  // re-rend des sections sans recharger la page, et une référence prise trop tôt
  // pointerait vers un nœud détaché.
  function refs() {
    feuille = document.querySelector('[data-hs-avail-sheet]');
    if (!feuille) return false;
    voile = document.querySelector('[data-hs-avail-scrim]');
    sortie = feuille.querySelector('[data-hs-avail-out]');
    return !!sortie;
  }

  function annuleFermeture() {
    if (minuteur) { clearTimeout(minuteur); minuteur = null; }
  }

  /* Placement au-dessus de 1025 px : sous la pastille, aligné sur son bord droit, puis
     ramené de force dans le viewport. C'est ce recadrage qui règle le défaut relevé par
     Yann — sur la carte la plus à gauche, un panneau aligné à droite sortait de la carte
     par la gauche et passait sous la colonne de navigation collante. */
  function placer(btn) {
    var r = btn.getBoundingClientRect();
    var marge = 8;

    // Mesurer hors champ avant de poser : la surcouche vient d'être révélée et porte
    // encore les coordonnées de l'ouverture précédente.
    feuille.style.left = '-9999px';
    feuille.style.top = '0px';
    var l = feuille.offsetWidth;
    var h = feuille.offsetHeight;

    var x = r.right - l;
    x = Math.max(marge, Math.min(x, window.innerWidth - l - marge));

    var y = r.bottom + 4;
    if (y + h > window.innerHeight - marge) {
      var dessus = r.top - h - 4;
      y = dessus >= marge ? dessus : Math.max(marge, window.innerHeight - h - marge);
    }

    feuille.style.left = Math.round(x) + 'px';
    feuille.style.top = Math.round(y) + 'px';
  }

  /* Sous 1025 px la surcouche pose un voile plein écran, déplace le focus dedans et
     bloque ce qu'il y a derrière : c'est une boîte de dialogue, et elle doit le dire.
     Le rôle est posé ICI et non dans le Liquid parce qu'il dépend de la largeur, qu'un
     attribut statique ne peut pas connaître — au survol, la même surcouche n'est qu'une
     infobulle et un `role="dialog"` y serait faux. */
  function modeDialogue(actif) {
    if (actif) {
      feuille.setAttribute('role', 'dialog');
      feuille.setAttribute('aria-modal', 'true');
      feuille.setAttribute('aria-labelledby', 'hs-avail-sheet-title');
      document.body.classList.add(CORPS_OUVERT);
    } else {
      feuille.removeAttribute('role');
      feuille.removeAttribute('aria-modal');
      feuille.removeAttribute('aria-labelledby');
      document.body.classList.remove(CORPS_OUVERT);
    }
  }

  function croix() {
    return feuille && feuille.querySelector('[data-hs-avail-close]');
  }

  function ouvrir(btn, clic) {
    if (!refs()) return;
    annuleFermeture();

    var texte = btn.getAttribute('data-hs-avail-text') || '';
    var statut = btn.getAttribute('data-hs-avail-statut') || 'unknown';
    if (!texte) return;

    sortie.textContent = texte;
    // La couleur du point suit `.hs-availsheet--<statut> .hs-availsheet__dot` : la classe
    // se pose sur la surcouche, pas sur le point. Un sélecteur descendant ne s'applique
    // pas quand la classe d'état est portée par l'élément lui-même.
    feuille.className = 'hs-availsheet hs-availsheet--' + statut;

    if (declencheur && declencheur !== btn) declencheur.setAttribute('aria-expanded', 'false');
    declencheur = btn;
    if (clic) epingle = true;
    btn.setAttribute('aria-expanded', 'true');

    feuille.hidden = false;

    if (feuilleBas()) {
      // Les coordonnées en style inline d'une ouverture au survol battraient l'ancrage
      // en bas posé par le CSS : elles sont effacées.
      feuille.style.left = '';
      feuille.style.top = '';
      if (voile) voile.hidden = false;
      modeDialogue(true);
      if (clic) { var c = croix(); if (c) c.focus(); }
    } else {
      if (voile) voile.hidden = true;
      modeDialogue(false);
      placer(btn);
    }
  }

  function fermer(rendreFocus) {
    annuleFermeture();
    if (!feuille) return;
    var etaitEpingle = epingle;
    feuille.hidden = true;
    feuille.style.left = '';
    feuille.style.top = '';
    if (voile) voile.hidden = true;
    modeDialogue(false);
    if (declencheur) {
      declencheur.setAttribute('aria-expanded', 'false');
      // Rendre le focus au déclencheur : sans cela il retombe sur le <body> et la
      // navigation au clavier repart du haut de la page. Seulement si l'ouverture était
      // délibérée — au survol, déplacer le focus volerait la position de l'utilisateur.
      if (rendreFocus && etaitEpingle) declencheur.focus();
    }
    declencheur = null;
    epingle = false;
  }

  function fermerBientot() {
    annuleFermeture();
    minuteur = setTimeout(function () { fermer(false); }, DELAI_FERMETURE);
  }

  /* --- Le doigt et le clavier ---------------------------------- */

  document.addEventListener('click', function (e) {
    var cible = e.target;
    if (!cible || !cible.closest) return;

    if (cible.closest('[data-hs-avail-close]')) {
      e.preventDefault();
      e.stopPropagation();
      fermer(true);
      return;
    }

    if (cible.closest('[data-hs-avail-scrim]')) {
      e.preventDefault();
      fermer(true);
      return;
    }

    var btn = cible.closest('[data-hs-avail-btn]');
    if (btn) {
      e.preventDefault();
      // `stopPropagation` est INDISPENSABLE : le bouton vit à l'intérieur de la carte,
      // dont l'image et le titre sont des liens vers la fiche produit. Sans lui, un
      // doigt sur la pastille ouvrirait la surcouche ET naviguerait.
      e.stopPropagation();
      if (declencheur === btn && feuille && !feuille.hidden) {
        // Déjà ouverte par le SURVOL : le clic l'épingle au lieu de la refermer. Sans
        // cela, sur un écran tactile large — où `mouseover` précède `click` — la
        // pastille s'ouvrirait et se refermerait dans le même geste.
        if (epingle) fermer(true);
        else epingle = true;
      } else {
        ouvrir(btn, true);
      }
      return;
    }

    if (feuille && !feuille.hidden && !cible.closest('[data-hs-avail-sheet]')) fermer(false);
  });

  document.addEventListener('keydown', function (e) {
    if (!feuille || feuille.hidden) return;

    if (e.key === 'Escape' || e.key === 'Esc') { fermer(true); return; }

    // Piège de focus, uniquement en mode boîte de dialogue. La feuille ne contient qu'un
    // seul élément focusable — sa croix —, donc le piège se réduit à l'y ramener : sans
    // lui, le Tab suivant parcourrait une page entièrement recouverte par le voile.
    if (e.key === 'Tab' && feuilleBas()) {
      var c = croix();
      if (c) { e.preventDefault(); c.focus(); }
    }
  });

  /* --- La souris ------------------------------------------------ */

  // `mouseover` et non `mouseenter` : seul le premier remonte, et la délégation au
  // document est obligatoire ici — voir l'en-tête de fichier.
  document.addEventListener('mouseover', function (e) {
    if (!survolPossible() || feuilleBas()) return;
    var cible = e.target;
    if (!cible || !cible.closest) return;

    if (cible.closest('[data-hs-avail-sheet]')) { annuleFermeture(); return; }

    var btn = cible.closest('[data-hs-avail-btn]');
    if (btn) { ouvrir(btn, false); return; }

    if (declencheur && !epingle) fermerBientot();
  });

  /* --- Ce qui invalide la position ------------------------------ */

  // Au survol la surcouche est ancrée à un élément de la page : dès que celui-ci défile,
  // la position calculée est fausse. On ferme plutôt que de recalculer à chaque image.
  // EN PHASE DE CAPTURE : un événement `scroll` émis par un élément ne remonte pas
  // jusqu'à `window`, et plusieurs conteneurs du thème défilent en interne — les
  // panneaux de recherche, les tiroirs. Un écouteur posé sur `window` les manquerait.
  // Au doigt, en revanche, la feuille est ancrée au bas de l'écran : elle doit survivre.
  document.addEventListener('scroll', function () {
    if (feuille && !feuille.hidden && !feuilleBas()) fermer(false);
  }, { capture: true, passive: true });

  // NE FERMER QUE SI LE PALIER A CHANGÉ. iOS Safari et Chrome Android émettent `resize`
  // quand la barre d'adresse se rétracte, c'est-à-dire au premier geste de défilement :
  // fermer sur tout `resize` refermait la feuille en pleine lecture.
  var palier = feuilleBas();
  window.addEventListener('resize', function () {
    var p = feuilleBas();
    if (p === palier) return;
    palier = p;
    if (feuille && !feuille.hidden) fermer(false);
  });
})();
